<template>
  <div v-if="game" class="pravo-sirsi__control">
    <div class="pravo-sirsi__control__leave">
      <div v-if="!me.isOwner" class="pravo-sirsi__control__leave__button">
        <div class="pravo-sirsi__control__leave__button__img">
          <div class="pravo-sirsi__control__leave__button__img__img"></div>
        </div>
        <button
          class="pravo-sirsi__control__leave__button__text button"
          @click="leaveGame"
        >
          Leave the game
        </button>
      </div>
    </div>
    <div class="pravo-sirsi__control__game">{{ game.name }}</div>
    <div class="pravo-sirsi__control__rounds">
      {{ game.turn }}/{{ game.maxTurn }} rounds
    </div>
         <div v-if="isItDemo()" class="pravo-sirsi__control__ready__button">
        <button
          class="pravo-sirsi__control__ready__button__text button"
          @click="readyGame"
        >
          {{ readyText }}
        </button>
      </div>
    <div class="pravo-sirsi__control__state">
      <template v-if="game.active"></template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Control",
  data() {
    return {
      isLoading: false,
      ready: false,
      readyText: "Ready"
    };
  },
  computed: {
    ...mapGetters({
      game: "joinedGame",
      me: "lobbyMe",
    }),
  },
  methods: {
    async leaveGame() {
      const result = await this.$store.dispatch("leaveGame");
      if (result) {
        await this.$router.push({ name: "Join" });
      }
    },
    async readyGame(){
      if(this.ready == false){
        this.ready = true
        this.readyText = "Not ready"
      }else{
        this.ready = false;
         this.readyText = "Ready"
      }
      await this.$store.dispatch("readyDemoGame", this.ready);
    },
    isItDemo(){
      if(this.game.type == "DEMO"){
        return true
      }else{
        return false
      }
     
    }
  },
};
</script>
